import React from 'react';
import ReactApexChart from 'react-apexcharts';

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: 'line-chart',
          zoom: {
            enabled: false,
          },
        },
        xaxis: {
          categories: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
        },
        yaxis: {
          min: 0,
          max: 100000,
          tickAmount: 15,
        },
        annotations: {
          yaxis: [
            {
              y: 90000,
              y2: 100000,
              borderColor: 'rgb(225, 116, 76)',
              borderWidth: 0,
              fillColor: 'rgb(225, 116, 76)',
            },
            {
              y: 70000,
              y2: 90000,
              borderColor: 'rgb(206, 104, 104)',
              borderWidth: 0,
              fillColor: 'rgb(206, 104, 104)',
            },
            {
              y: 50000,
              y2: 70000,
              borderColor: 'rgb(88, 130, 92)',
              borderWidth: 0,
              fillColor: 'rgb(88, 130, 92)',
            },
            {
              y: 30000,
              y2: 50000,
              borderColor: 'rgb(247, 184, 1)',
              borderWidth: 0,
              fillColor: 'rgb(247, 184, 1)',
            },
            {
              y: 0,
              y2: 30000,
              borderColor: 'rgb(123, 116, 184)',
              borderWidth: 0,
              fillColor: 'rgb(123, 116, 184)',
            },
          ],
        },
      },
      series: [
        {
          name: 'My Dataset',
          data: [5,10,20,30,50],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              gradientToColors: ['#000'],
              shadeIntensity: 1,
              type: 'vertical',
              opacityFrom: 0.1,
              opacityTo: 0.2,
              stops: [0, 100],
            },
          },
        },
      ],
    };
  }

  render() {
    return (
      <div className="line-chart">
        <div className="legend">
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: 'rgb(123, 116, 184)' }}></div>
            <div className="legend-label">5 Years</div>
          </div>
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: 'rgb(247, 184, 1)' }}></div>
            <div className="legend-label">10 Years</div>
          </div>
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: 'rgb(88, 130, 92)' }}></div>
            <div className="legend-label">20 Years</div>
          </div>
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: 'rgb(206, 104, 104)' }}></div>
            <div className="legend-label">30 Years</div>
          </div>
          <div className="legend-item">
            <div className="legend-color" style={{ backgroundColor: 'rgb(225, 116, 76)' }}></div>
            <div className="legend-label">50 Years</div>
          </div>
          {/* Add more legend items for other annotations as needed */}
        </div>
        <div className="chart">
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="line"
            height={350}
          />
        </div>
      </div>
    );
  }
}

export default LineChart;
